import Cookies from "js-cookie";

// El rol solo se usa para mostrar/ocultar opciones en la interfaz.
// La seguridad real la valida el backend en cada petición (requireRol).
export const ROLES = { SUPERADMIN: "superadmin", ADMIN: "admin", DIGITADOR: "digitador" };

// login privado del superadmin (dueño del sistema). El backend también valida
// que el superadmin solo entre por aquí y los demás solo por "/".
export const RUTA_LOGIN_SUPERADMIN = "/NSSDjPMJipG";
export const ACCESO_SUPERADMIN = "superadmin";

// pantalla de inicio y de login según el rol
export const rutaInicio = (rol) => (rol === ROLES.SUPERADMIN ? "/administradores" : "/consulta");
export const rutaLogin = (rol) => (rol === ROLES.SUPERADMIN ? RUTA_LOGIN_SUPERADMIN : "/");

export const guardarSesion = ({ token, expiresIn, rol, username }) => {
  // expiresIn viene en segundos; js-cookie espera días
  const opciones = { expires: expiresIn / (60 * 60 * 24) };
  Cookies.set("token", token, opciones);
  Cookies.set("rol", rol, opciones);
  Cookies.set("username", username, opciones);
};

// Actualiza rol y nombre con lo que diga el backend (sesiones viejas sin
// rol guardado, o si el admin le cambió el rol al usuario).
// Devuelve true si algo cambió.
export const sincronizarDatosSesion = ({ rol, username }) => {
  const cambio = Cookies.get("rol") !== rol || Cookies.get("username") !== username;
  if (cambio) {
    const opciones = { expires: 1 };
    Cookies.set("rol", rol, opciones);
    Cookies.set("username", username, opciones);
  }
  return cambio;
};

export const cerrarSesion = () => {
  Cookies.remove("token");
  Cookies.remove("rol");
  Cookies.remove("username");
};

export const obtenerRol = () => Cookies.get("rol");
export const obtenerUsername = () => Cookies.get("username");
export const esAdmin = () => obtenerRol() === ROLES.ADMIN;
export const esSuperadmin = () => obtenerRol() === ROLES.SUPERADMIN;
